// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__certificate-wrapper,.card__online-meeting,.card__post{max-width:100%}@media (min-width:768px){.card__certificate-wrapper,.card__online-meeting,.card__post{max-width:680px}}.card-box-verify{border-width:4px 0 0 0;border-color:#1bc943;width:100%;max-width:680px}", ""]);
// Exports
module.exports = exports;
